import { Controller, Control, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Inputs } from "../Communications";
import { Input } from "shared/UI/Input/Input";
import { Textarea } from "shared/UI/Textarea/Textarea";

export const PushNotifications = ({ control, errors }: { control: Control<Inputs, any>; errors: FieldErrors<Inputs> }) => {
  const { t } = useTranslation();

  const httpsRegex =
    /^(?:$|https:\/\/(?:qa-wisdom\.healthassured\.org|sandbox-wisdom\.healthassured\.org|wisdom\.healthassured\.org|app\.wisdomwellbeing\.com)(?::\d{2,5})?(?:[/?#][^\s]*)?)$/i;

  return (
    <>
      <div>
        <Controller
          name={"title"}
          control={control}
          rules={{
            required: t("communications.pushNotifications.titleErrorMessage"),
          }}
          render={({ field: { onChange, value } }) => (
            <>
              <Input
                id="title"
                aria-label={t("communications.pushNotifications.titleLabel")}
                onChange={onChange}
                value={value}
                autoComplete="disabled"
                placeholder={t("communications.pushNotifications.titlePlaceholder")}
                label={t("communications.pushNotifications.titleLabel")}
                helperText={errors.title?.message}
                state={errors.title ? "error" : undefined}
              />
            </>
          )}
        />
      </div>
      <div>
        <Controller
          name={"body"}
          control={control}
          rules={{
            required: t("communications.pushNotifications.contentErrorMessage"),
          }}
          render={({ field: { onChange, value } }) => (
            <>
              <Textarea
                id="body"
                aria-label={t("communications.pushNotifications.contentLabel")}
                onChange={onChange}
                rows={8}
                placeholder={t("communications.pushNotifications.contentPlaceholder")}
                label={t("communications.pushNotifications.contentLabel")}
                helperText={errors.body?.message}
                value={value}
                state={errors.body ? "error" : undefined}
              />
            </>
          )}
        />
      </div>
      <div>
        <Controller
          name={"linkUrl"}
          control={control}
          rules={{
            validate: {
              fullUrlMatch: (v: string) => httpsRegex.test(v) || t("communications.pushNotifications.linkErrorMessage"),
            },
          }}
          render={({ field: { onChange, value } }) => (
            <>
              <Input
                id="linkUrl"
                aria-label={t("communications.pushNotifications.linkLabel")}
                onChange={onChange}
                value={value}
                autoComplete="disabled"
                placeholder={t("communications.pushNotifications.linkPlaceholder")}
                label={t("communications.pushNotifications.linkLabel")}
                helperText={errors.linkUrl?.message ?? t("communications.pushNotifications.linkHelperText")}
                state={errors.linkUrl ? "error" : "info"}
              />
            </>
          )}
        />
      </div>
    </>
  );
};
